import { IOption } from 'components/ui/Dropdown/Dropdown';

export const supportOptions: IOption[] = [
  {
    // translationKey: 'plans.premium',
    label: 'plans.premium',
    value: 'PREMIUM',
  },
  {
    // translationKey: 'plans.classic',
    label: 'plans.classic',
    value: 'CLASSIC',
  },
  {
    // translationKey: 'plans.enterprise',
    label: 'plans.enterprise',
    value: 'ENTERPRISE',
  },
];
